export enum SubscriptionStatus {
  IN_TEST = 'IN_TEST',
  ACTIVE = 'ACTIVE',
  SUSPEND = 'SUSPEND',
  CANCELED = 'CANCELED',
  REACTIVATING = 'REACTIVATING',
  TRIAL_EXPIRED = 'TRIAL_EXPIRED',
  LEGACY = 'LEGACY',
  BLOCKED = 'BLOCKED',
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/subscription-status.enum.ts